/* NAKED US : « You might also like ». Remplit <product-recommendations product limit intent> par le rendu de section
   des recommandations Shopify (/recommendations/products?section_id=…), comme la vitrine FR. */
(function () {
  'use strict';
  if (customElements.get('product-recommendations')) return;
  customElements.define('product-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.nkLoaded) return; this.dataset.nkLoaded = '1';
      var self = this, sec = this.closest('.shopify-section'); if (!sec) return;
      var sid = sec.id.replace('shopify-section-', '');
      var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
      var url = root + 'recommendations/products?product_id=' + encodeURIComponent(this.getAttribute('product')) +
        '&limit=' + encodeURIComponent(this.getAttribute('limit') || '8') + '&intent=' + encodeURIComponent(this.getAttribute('intent') || 'related') +
        '&section_id=' + encodeURIComponent(sid);
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html'), el = d.querySelector('product-recommendations');
        if (el && el.innerHTML.trim()) { self.innerHTML = el.innerHTML; self.dispatchEvent(new CustomEvent('nk:rail-loaded', { bubbles: true })); }
      }).catch(function () {});
    }
  });
})();
